import RadioButton from "@frameworks/web/components/generic/radioButton";
import React from "react";
import { Col, Row } from "react-bootstrap";
import BankAccount from "../CommonPaymentMethod/BankAccount";
export const DiffUpiId = [
    {
        value: "bA1",
        display: "",
    },
    {
        value: "bA2",
        display: "",
    },
    {
        value: "bA3",
        display: "",
    },
];
const DiffrentUpiIdData = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "BankAccountSectionOuter mt-2" }, props.upiList.map((item) => {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "BankAccountSection" },
                        React.createElement(RadioButton, { className: "common-radio-button paymentmethodradio", name: "upi", list: { display: "", value: item.upi }, onChange: () => {
                                props.setUPI(item.upi);
                            }, selected: props.selectedUPI }),
                        React.createElement(BankAccount, { sectionHeadleftTop: "UPI ID", sectionHeadleftBottom: item.upi, sectionHeadRightTop: "Bank Name", sectionHeadRightBottom: item.bankName }))));
            })))));
};
export default DiffrentUpiIdData;
